<template lang="pug">
.card-coupons-container(v-if="showCardCoupons")
  .title 限时抢券
  template(v-if="preparing")
    .shadow-cards
      .shadow-cards-item
      .shadow-cards-item
      .shadow-cards-item
  .body(v-show="!preparing")
    TimeCoupons(
      ref="timeCoupons",
      v-bind="$attrs",
      :activity="config.time",
      @coupon="$emit('coupon')",
      @showModule="showModule"
    )
</template>

<script>
import { getCommonConfig } from '@/api/card';
import { env } from '@hb/NBridge/lib/h5';
import TimeCoupons from './time-coupons';
import { getTokenAndKey } from '../../../utils';
import { FULI_MODULE_NAV } from '../consts';

export default {
  components: {
    TimeCoupons,
  },
  data() {
    return {
      preparing: true,
      config: {
        time: {},
      },
      env,
      showCardCoupons: true,
    };
  },
  methods: {
    async start() {
      const { token } = await getTokenAndKey();
      const { welfare } = await getCommonConfig({ token })
        .then((v) => v.data || {})
        .catch(() => ({}));
      if (!welfare) {
        this.showModule();
        return Promise.resolve();
      }

      this.config = welfare;
      this.preparing = false;
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.$refs.timeCoupons.getData().then(resolve);
        });
      });
    },
    showModule() {
      this.showCardCoupons = false;
      this.$emit('hideTab', FULI_MODULE_NAV.welfare_card_new);
    },
  },
};
</script>

<style lang="less" scoped>
.card-coupons-container {
  padding: 0.16rem;

  .shadow-cards-item {
    width: 100%;
    height: 0.71rem;
    background: #f7f9fa;
    border-radius: 0.04rem;

    &:not(:last-of-type) {
      margin-bottom: 0.08rem;
    }
  }

  .title {
    font-size: 0.16rem;
    color: #242729;
    margin-bottom: 0.1rem;
    font-weight: 500;
  }
}
</style>
